// Campus photo for /colleges/university-of-colorado-boulder: CC BY-SA 3.0, by MECU, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AOld_Main_-_Colorado.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-colorado-boulder/; credited under the photo.
const photo = {
    "slug": "university-of-colorado-boulder",
    "alt": "Old Main, a red brick building with a central tower, behind bare trees at the University of Colorado Boulder",
    "src": "/colleges/university-of-colorado-boulder/campus-1600.webp",
    "srcSmall": "/colleges/university-of-colorado-boulder/campus-800.webp",
    "srcMid": "/colleges/university-of-colorado-boulder/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-colorado-boulder/og.jpg",
    "title": "Old Main - Colorado",
    "author": "MECU",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AOld_Main_-_Colorado.jpg",
    "read": "2026-10-01"
};

export default photo;
